<template>
  <label class="photoInputOuter">
    <FormKit
      :classes="{
        wrapper: 'photoInputWrapper',
        input: 'photoInput',
        inner: 'photoInputInner'
      }"
      :name="'pictureUrl'"
      type="file"
      accept=".jpg,.jpeg,.svg,.png"
    />
    <div class="photoInputIcon">
      <img src="../../../assets/icons/DownImg.svg" alt="Photo Icon" />
    </div>
  </label>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Photo'
})
export default class Photo extends Vue {}
</script>

<style lang="scss">
.photoInputOuter {
  width: 18px;
  height: 18px;
  position: relative;
  cursor: pointer;
  .formkit-outer {
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .photoInputIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: $backgroundImg;
    img {
      background-color: $backgroundImg;
    }
  }
  .photoInputWrapper {
    width: 18px;
    height: 18px;
    border: none;
    & .photoInput {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
      opacity: 0;
    }
    & .photoInputInner {
      .photoInputIcon {
        width: 18px;
        height: 18px;
        display: flex;
        justify-content: center;
      }
    }
  }
}

.formkit-no-files {
  opacity: 0;
  cursor: default;
}
</style>
